'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const icon = require('../Icon/icon.js');
const textInput_types = require('./textInput.types.js');
const textInput_style = require('./textInput.style.js');

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

/**
 * styled components wrappers need to be outside the text input component
 * they should not get remounted every time props get updated.
 */

var TextInputWrapper = textInput_style.styledTextInput;
var IconWrapper = textInput_style.styledIcons;
var CloseIconWrapper = textInput_style.styledButtonIcons;
var getInputClassName = function getInputClassName(hasRightIcon, hasLeftIcon) {
  var temp = [];
  if (hasRightIcon) {
    temp.push('right');
  }
  if (hasLeftIcon) {
    temp.push('left');
  }
  return temp.join(' ');
};
var TextInput = function TextInput(_ref) {
  var placeHolder = _ref.placeHolder,
    className = _ref.className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? textInput_types.TextInputTypes.PRIMARY : _ref$type,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? {} : _ref$theme,
    ariaLabel = _ref.ariaLabel,
    ariaLabelReset = _ref.ariaLabelReset,
    _ref$handlers = _ref.handlers,
    handlers = _ref$handlers === void 0 ? {} : _ref$handlers,
    _ref$resetHandlers = _ref.resetHandlers,
    resetHandlers = _ref$resetHandlers === void 0 ? {} : _ref$resetHandlers,
    value = _ref.value,
    inputRef = _ref.refElement,
    _ref$cancelButton = _ref.cancelButton,
    cancelButton = _ref$cancelButton === void 0 ? false : _ref$cancelButton,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$iconType = _ref.iconType,
    iconType = _ref$iconType === void 0 ? '' : _ref$iconType,
    iconColor = _ref.iconColor,
    _ref$inputType = _ref.inputType,
    inputType = _ref$inputType === void 0 ? 'text' : _ref$inputType,
    cancelButtonRef = _ref.cancelButtonRef,
    _ref$additionalProps = _ref.additionalProps,
    additionalProps = _ref$additionalProps === void 0 ? {} : _ref$additionalProps,
    spellCheck = _ref.spellCheck,
    _ref$shape = _ref.shape,
    shape = _ref$shape === void 0 ? textInput_types.TextInputShapes.DEFAULT : _ref$shape;
  var inputElRef = inputRef || React.useRef(null);
  var themeType = theme.dark ? 'dark' : type;
  var _useState = React.useState(cancelButton && value !== undefined && value !== ''),
    _useState2 = _slicedToArray(_useState, 2),
    cancelBtnVisibility = _useState2[0],
    setCancelBtnVisibility = _useState2[1];
  React.useEffect(function () {
    setCancelBtnVisibility(cancelButton && inputElRef.current.value !== undefined && inputElRef.current.value !== '');
  }, [cancelButton, setCancelBtnVisibility, inputElRef]);
  var onClearInput = function onClearInput() {
    if (inputElRef && inputElRef.current) {
      inputElRef.current.value = '';
      inputElRef.current.focus();
      setCancelBtnVisibility(false);
    }
  };
  var onValueChange = function onValueChange() {
    setCancelBtnVisibility(inputElRef.current.value !== '');
  };

  /// set default reset event handlers
  var defaultInputHandlers = {};
  var defaultResetHandlers = {};
  if (cancelButton) {
    defaultResetHandlers.onClick = onClearInput;
    defaultInputHandlers.onChange = onValueChange;
  }

  // add default reset event handlers to merged list
  var completeResetButtonProps = _objectSpread({}, defaultResetHandlers);
  var completeInputHandlersProps = _objectSpread({}, defaultInputHandlers);
  Object.keys(resetHandlers).forEach(function (key) {
    completeResetButtonProps[key] = function (e) {
      if (defaultResetHandlers[key]) {
        defaultResetHandlers[key](e);
      }
      resetHandlers[key](e);
    };
  });
  Object.keys(handlers).forEach(function (key) {
    completeInputHandlersProps[key] = function (e) {
      if (defaultInputHandlers[key]) {
        defaultInputHandlers[key](e);
      }
      handlers[key](e);
    };
  });
  var closeIconWrapperProps = _objectSpread({
    type: 'reset',
    'aria-label': ariaLabelReset || 'Reset',
    className: 'right',
    theme: themeType,
    ref: cancelButtonRef
  }, completeResetButtonProps);
  var mergedInputProps = _objectSpread(_objectSpread({}, completeInputHandlersProps), additionalProps);
  var completeTextInputProps = _objectSpread({
    type: inputType,
    placeholder: placeHolder,
    className: getInputClassName(cancelButton, iconType),
    'aria-label': ariaLabel || placeHolder || '',
    ref: inputElRef,
    required: required,
    value: value,
    spellCheck: spellCheck
  }, mergedInputProps);
  var iconWrapperProps = {
    className: 'left'
  };
  return /*#__PURE__*/React__default.createElement(TextInputWrapper, {
    theme: themeType,
    className: className,
    $shape: shape
  }, iconType !== '' && /*#__PURE__*/React__default.createElement(IconWrapper, iconWrapperProps, /*#__PURE__*/React__default.createElement(icon, {
    name: iconType,
    width: 15,
    fill: iconColor || textInput_types.TextInputColors[themeType].icon
  })), /*#__PURE__*/React__default.createElement("input", completeTextInputProps), cancelButton && cancelBtnVisibility && /*#__PURE__*/React__default.createElement(CloseIconWrapper, closeIconWrapperProps, /*#__PURE__*/React__default.createElement(icon, {
    name: "close",
    width: 13
  })));
};
const TextInput$1 = styled.withTheme(TextInput);

module.exports = TextInput$1;
